var util = require('./util'),
    layout = require('./layout'),
    quickview = require('./quickview'),
    carousel = require('./carousel'),
    searchsuggest = require('./searchsuggest'),
    Constants = require('./constants'),
    CSSConstants = require('./cssconstants'),
    ajax = require('./ajax'),
    urls = (typeof window !== "undefined" ? window['Urls'] : typeof global !== "undefined" ? global['Urls'] : null),
    getAndInsertCSRFToken = require('./csrf');

/**
 * @description Moved from SG app.js
 */
function initializeEvents() {
    var controlKeys = ['8', '13', '46', '45', '36', '35', '38', '37', '40', '39'];

    $('body')
        .on('keydown', 'textarea[data-character-limit]', function (e) {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length;

            if ((charsUsed >= charsLimit) && (controlKeys.indexOf(e.which.toString()) < 0)) {
                e.preventDefault();
            }
        })
        .on('change keyup mouseup', 'textarea[data-character-limit]', function () {
            var text = $.trim($(this).val()),
                charsLimit = $(this).data('character-limit'),
                charsUsed = text.length,
                charsRemain = charsLimit - charsUsed;

            if (charsRemain < 0) {
                $(this).val(text.slice(0, charsRemain));
                charsRemain = 0;
            }

            $(this).next('div.char-count').find('.char-remain-count').html(charsRemain);
        })
        .on('click', Constants.CLASS_PRINT_VERSION, function(e) {
            e.preventDefault();
            window.print();
        });

    /**
     * initialize search suggestions, pending the value of the site preference(enhancedSearchSuggestions)
     * this will either init the legacy(false) or the beta versions(true) of the the search suggest feature.
     * */
    $(Constants.CLASS_HEADER_SEARCH).each(function () {
        new searchsuggest($(this), Resources.SIMPLE_SEARCH);
    });

    // add show/hide navigation elements
    $('.secondary-navigation .toggle').click(function () {
        $(this).toggleClass('expanded').next('ul').toggle();
    });

    // add generic toggle functionality
    $('.toggle').each(function(index, item) {
        $(this).next('.toggle-content').toggleClass('g-hidden', !$(this).hasClass('expanded'));
    });
    $('.toggle').click(function (e) {
        e.preventDefault();
        $(this).toggleClass('expanded').next('.toggle-content').trigger('toggled', {'expanded': $(this).hasClass('expanded')}).toggleClass('g-hidden', !$(this).hasClass('expanded'));
    });

    // subscribe email box
    var $subscribeEmail = $('.subscribe-email');
    if ($subscribeEmail.length > 0)    {
        $subscribeEmail.focus(function () {
            var val = $(this.val());
            if (val.length > 0 && val !== Resources.SUBSCRIBE_EMAIL_DEFAULT) {
                return; // do not animate when contains non-default value
            }

            $(this).animate({color: '#999999'}, 500, 'linear', function () {
                $(this).val('').css('color', '#333333');
            });
        }).blur(function () {
            var val = $.trim($(this.val()));
            if (val.length > 0) {
                return; // do not animate when contains value
            }
            $(this).val(Resources.SUBSCRIBE_EMAIL_DEFAULT)
                .css('color', '#999999')
                .animate({color: '#333333'}, 500, 'linear');
        });
    }

    $('.p-privacy_policy').on('click', function (e) {
        e.preventDefault();
        dialog.open({
            url: $(e.target).attr('href'),
            options: {
                height: 600
            }
        });
    });

    setMobileMenuGrid();

    // main menu toggle
    $('.menu-toggle').on('click', function (e) {
        e.stopPropagation();
        $('html').toggleClass('js-menu_active');
        // Redesign-only: reset level state when the menu closes
        if ($('html').hasClass('m-mobile-menu-config-enabled') && !$('html').hasClass('js-menu_active')) {
            resetMobileMenuPanelScroll($('.b-menu_main-level_2_wrapper, .tertiary-level-navigation'));
            $('.tertiary-level-wrapper.m-tertiary-active').removeClass('m-tertiary-active');
            $('.b-light-header-menu-level_1_item.active').removeClass('active');
            updateMenuTopPanel();
        }
    });

    $(document).on('click', 'html.js-menu_active', function(e) {
        var container = $("#navigation");

        // if the target of the click isn't the container nor a descendant of the container
        if ($('html').hasClass('js-menu_active') && !container.is(e.target) && container.has(e.target).length === 0) {
            $('html').toggleClass('js-menu_active');
            // Redesign-only: reset level state when the menu closes
            if ($('html').hasClass('m-mobile-menu-config-enabled')) {
                resetMobileMenuPanelScroll($('.b-menu_main-level_2_wrapper, .tertiary-level-navigation'));
                $('.tertiary-level-wrapper.m-tertiary-active').removeClass('m-tertiary-active');
                $('.b-light-header-menu-level_1_item.active').removeClass('active');
                updateMenuTopPanel();
            }
        }
    });

    // Classic header accordion (uses .menu-item-toggle chevron icons)
    $('.menu-category li .menu-item-toggle').on('click', function (e) {
        e.preventDefault();
        var $parentLi = $(e.target).closest('li');
        $parentLi.siblings('li').removeClass('active').find('.menu-item-toggle').removeClass('fa-chevron-up active').addClass('fa-chevron-right');
        $parentLi.toggleClass('active');
        $(e.target).toggleClass('fa-chevron-right fa-chevron-up active');
    });

    // Develop light header (redesign disabled): accordion via +/- icon or category link
    $(document).on('click', '.b-light-header-menu .b-light-header-menu__toggle-icon, .b-light-header-menu .menu-button-toggle', function (e) {
        if ($('html').hasClass('m-mobile-menu-config-enabled')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        var $parentLi = $(this).closest('.b-light-header-menu-level_1_item');
        if (!$parentLi.length) {
            return;
        }
        $parentLi.siblings('.b-light-header-menu-level_1_item').removeClass('active');
        $parentLi.toggleClass('active');
    });

    // Redesign menu (config enabled): whole level 1 tile is the trigger for level 2
    $('.menu-category li .b-light-header-menu-level_1_link_wrapper').on('click', function (e) {
        if (!$('html').hasClass('m-mobile-menu-config-enabled')) {
            return;
        }
        e.preventDefault();
        var $parentLi = $(this).closest('li');
        $parentLi.siblings('li').removeClass('active');
        $parentLi.toggleClass('active');
        $('.tertiary-level-wrapper.m-tertiary-active').removeClass('m-tertiary-active');
        updateMenuTopPanel();
    });
    // close the slide-in second level menu (mobile)
    $(document).on('click', '.js-menu_level_2_back', function (e) {
        e.preventDefault();
        e.stopPropagation();
        var $item = $(this).closest('.b-light-header-menu-level_1_item');
        resetMobileMenuPanelScroll($item.find('.b-menu_main-level_2_wrapper'));
        $item.removeClass('active');
        if ($('html').hasClass('m-mobile-menu-config-enabled')) {
            updateMenuTopPanel();
        }
    });
    // Redesign mobile menu: open the slide-in third level
    $(document).on('click', '.tertiary-level-toggle', function () {
        if (!$('html').hasClass('m-mobile-menu-config-enabled')) {
            return;
        }
        $(this).closest('.tertiary-level-wrapper').addClass('m-tertiary-active');
        updateMenuTopPanel();
    });
    // Redesign mobile menu top panel: back from L2 to L1
    $(document).on('click', '.js-menu_top_back', function (e) {
        if (!$('html').hasClass('m-mobile-menu-config-enabled')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        var $openTertiary = $('.tertiary-level-wrapper.m-tertiary-active');
        if ($openTertiary.length) {
            resetMobileMenuPanelScroll($openTertiary.find('.tertiary-level-navigation'));
            $openTertiary.removeClass('m-tertiary-active');
        } else {
            var $activeItem = $('.b-light-header-menu-level_1_item.active');
            resetMobileMenuPanelScroll($activeItem.find('.b-menu_main-level_2_wrapper'));
            $activeItem.removeClass('active');
        }
        updateMenuTopPanel();
    });
    // Redesign mobile menu top panel: close the whole menu
    $(document).on('click', '.js-menu_close', function (e) {
        if (!$('html').hasClass('m-mobile-menu-config-enabled')) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        resetMobileMenuPanelScroll($('.b-menu_main-level_2_wrapper, .tertiary-level-navigation'));
        $('.tertiary-level-wrapper.m-tertiary-active').removeClass('m-tertiary-active');
        $('.b-light-header-menu-level_1_item.active').removeClass('active');
        updateMenuTopPanel();
        $('html').removeClass('js-menu_active');
    });
    $('.user-account').on('click', function (e) {
        e.preventDefault();
        $(this).parent('.user-info').toggleClass('active');
    });

    if(!layout.isDesktop()) {
        $(window).resize(function() {
            $('.' + CSSConstants.DIALOG_CONTENT + ':visible').each(function() {
                $(this).dialog('option', 'position', $(this).dialog('option', 'position'));
            });
        });
    }

    $(document).on('recommendations-loaded', function() {
        carousel.initCarousel($(Constants.CLASS_RECOMMENDER).find(Constants.CLASS_CAROUSEL));
    });

    $(document).trigger("component-inited");

    $(document).on('minicart.updated product.afterAddedToCart', invalidateDeliveryPromotion);

    $(document).on('minicart.updated product.afterAddedToCart', updateMenuQuantity);

    invalidateDeliveryPromotion();
}

/**
 * @description Moved from SG app.js
 * @private
 * @function
 * @description Adds class ('js') to html for css targeting and loads js specific styles.
 */
function initializeDom() {
    // add class to html for css targeting
    $('html').addClass('js');
    if (SitePreferences.LISTING_INFINITE_SCROLL) {
        $('html').addClass('infinite-scroll');
    }
    // load js specific styles
    util.limitCharacters();
    util.checkLimitMessage();

    if (document.cookie.length === 0) {
        $('<div/>').addClass('browser-compatibility-alert' + ' ' + CSSConstants.B_COOKIES_JS_ERROR).append($('<p/>').addClass('browser-error').html(Resources.COOKIES_DISABLED)).appendTo('#browser-check');
    }

    //generate csrf for form
    var forms = $("form[data-csrfgenerate='true']");

    for (var i = 0; i < forms.length; i++) {
        getAndInsertCSRFToken(forms[i]);
    }

    checkItemWideFlyoutMenu();
}

function setMobileMenuGrid() {
    var $nav = $('.b-light-header-menu');
    var $menu = $('.b-light-header-menu-level_1');
    var mobileMenuConfig = (typeof SitePreferences !== 'undefined' && SitePreferences.MOBILE_MENU_CONFIGURATION) || {};
    var gridFromDom = $menu.attr('data-mobile-menu-grid');
    var rowsFromDom = $menu.attr('data-mobile-menu-rows');
    var enabledAttr = $menu.attr('data-mobile-menu-enabled');
    // Prefer DOM flag from ISML (authoritative for this page render)
    var isEnabled = enabledAttr != null
        ? enabledAttr === 'true'
        : mobileMenuConfig.enabled === true;
    var gridTemplateAreas = gridFromDom || mobileMenuConfig.gridTemplateAreas;
    var gridTemplateRows = rowsFromDom || mobileMenuConfig.gridTemplateRows;

    // enabled=false → develop list menu (no redesign classes / CSS vars)
    $nav.toggleClass('m-mobile-menu-config-enabled', isEnabled);
    $menu.toggleClass('m-mobile-menu-config-enabled', isEnabled);
    $('html').toggleClass('m-mobile-menu-config-enabled', isEnabled);

    if (!isEnabled || !gridTemplateAreas) {
        document.documentElement.style.removeProperty('--mobile-menu-grid');
        document.documentElement.style.removeProperty('--mobile-menu-rows');
        return;
    }

    document.documentElement.style.setProperty('--mobile-menu-grid', gridTemplateAreas);
    if (gridTemplateRows) {
        document.documentElement.style.setProperty('--mobile-menu-rows', gridTemplateRows);
    }
}

/**
 * @description Resets scroll on closing L2/L3 panels so a deep scroll position
 * is not kept when the panel slides away (helps avoid iOS touch freezes).
 * @param {JQuery} $panels
 */
function resetMobileMenuPanelScroll($panels) {
    if (!$panels || !$panels.length) {
        return;
    }
    $panels.each(function () {
        this.scrollTop = 0;
    });
}

/**
 * @description iOS Safari can freeze scrolling on elements that use
 * -webkit-overflow-scrolling: touch after overflow is toggled to hidden.
 * Force a brief reflow so L1 becomes scrollable again after leaving L2/L3.
 * @param {JQuery} $nav
 */
function recoverMobileMenuScroll($nav) {
    var el = $nav && $nav.get(0);
    if (!el) {
        return;
    }
    var scrollTop = el.scrollTop;
    el.style.overflowY = 'hidden';
    // Force layout so WebKit drops the stale scroll port
    void el.offsetHeight;
    el.style.overflowY = '';
    el.scrollTop = scrollTop;
}

/**
 * @description Syncs the fixed top panel of the redesign mobile menu with the
 * current level. L1: close only. L2: back + close; title filled only when JSON
 * level2.headerTitle is true (class on L1 item / L2 wrapper). L3: tertiary title.
 */
function updateMenuTopPanel() {
    var $nav = $('.b-light-header-menu');
    var $activeTertiary = $nav.find('.tertiary-level-wrapper.m-tertiary-active').first();
    var $activeItem = $nav.find('.b-light-header-menu-level_1_item.active').first();
    var wasLevel2Active = $nav.hasClass('m-level2-active');

    if ($activeTertiary.length) {
        var tertiaryTitle = $activeTertiary.find('.tertiary-level-toggle').first().text().trim();
        $nav.addClass('m-level2-active');
        $('.js-menu_top_title').text(tertiaryTitle);
    } else if ($activeItem.length) {
        // level2.headerTitle → single L2 title in the top bar (not banner/standalone)
        var showLevel2HeaderTitle = $activeItem.hasClass('m-level2-header-title') ||
            $activeItem.find('.b-menu_main-level_2_wrapper').hasClass('m-level2-header-title');
        var title = '';
        if (showLevel2HeaderTitle) {
            // L1 title span is omitted when titleShow=false — use data-category-name
            title = $activeItem.find('.b-light-header-menu__icon-wrapper').first().text().trim();
            if (!title) {
                title = $activeItem.find('.b-light-header-menu-level_1_link').first().attr('data-category-name') || '';
                title = title.trim();
            }
        }
        $nav.addClass('m-level2-active');
        $('.js-menu_top_title').text(title);
    } else {
        $nav.removeClass('m-level2-active');
        $('.js-menu_top_title').text('');
        if (wasLevel2Active) {
            recoverMobileMenuScroll($nav);
        }
    }
}

function checkItemWideFlyoutMenu() {
    var countItemsWideFlyoutMenu = $(".m-flyout_full .b-menu_main-level_2_wrapper").find('img').length;

    if (countItemsWideFlyoutMenu == 1) {
        var menuFullWight = $(".menu-category.level-1.b-menu_main-level_1").css('width');
        var menuItemWight = $(".m-flyout_full").css('width');
        var offsetItem = $(".m-flyout_full").position()['left'];

        var offsetRight = parseInt(menuFullWight) - parseInt(menuItemWight) - offsetItem;
        $(".m-flyout_full .b-menu_main-level_2_wrapper").css('right',offsetRight);
    }
}

function invalidateDeliveryPromotion() {
    var approachingFreeStandardUKShipping = $('.js-approachingfreestandardukshipping');
    var approachingFreeNextDayUKShipping = $('.js-approachingfreenextdayukshipping');
    var qualifiedFreeNextDayUKShipping = $('.js-qualifiedfreenextdayukshipping');
    var subtotal = parseInt($('.js-totalvalue').attr('data-totalvalue'));

    approachingFreeStandardUKShipping.addClass('hidden');
    approachingFreeNextDayUKShipping.addClass('hidden');
    qualifiedFreeNextDayUKShipping.addClass('hidden');

    if (subtotal >= SitePreferences.FREE_NEXT_DAY_UK_SHIPPING_THRESHOLD) {
        $('.js-qualifiedfreenextdayukshipping').removeClass('hidden');
    } else if (subtotal >= SitePreferences.FREE_STANDARD_UK_SHIPPING_THRESHOLD) {
        $('.js-approachingfreenextdayukshipping').removeClass('hidden');
        $('.js-discountdistance').html(SitePreferences.FREE_NEXT_DAY_UK_SHIPPING_THRESHOLD - subtotal);
    } else if (subtotal >= SitePreferences.FREE_STANDARD_UK_SHIPPING_ALERT) {
        $('.js-approachingfreestandardukshipping').removeClass('hidden');
        $('.js-discountdistance').html(SitePreferences.FREE_STANDARD_UK_SHIPPING_THRESHOLD - subtotal);
    }
}

function updateMenuQuantity() {
    var quantityHeader = $('.js-quantity-header');
    var quantityMenu = $('.js-menu-cart-quantity');
    var quantityMenuWraper = $('.js-menu-quantity-wrapper');
    if (quantityHeader.length && quantityMenuWraper.length && quantityMenu.length) {
        var quantity = quantityHeader.attr('data-quantity');
        if (quantity) {
            quantityMenu.html(quantity);
        }
        if ( quantity != "0" ) {
            quantityMenuWraper.removeClass('g-hidden');
        } else {
            quantityMenuWraper.addClass('g-hidden');
        }
    }
}

module.exports = {
    'init' : function () {
        initializeDom();
        initializeEvents();
    }
};